import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { AbstractService } from 'src/app/services/abstract.service';
import { CicloVidaService } from 'src/app/services/ciclo-vida.service';

@Component({
  selector: 'habil-ciclo-vida',
  templateUrl: './ciclo-vida.component.html',
  styleUrls: ['./ciclo-vida.component.scss']
})
export class CicloVidaComponent implements OnInit {

  constructor(private bcservice: BreadcrumbService, public service: CicloVidaService, titleService: Title) {
    this.bcservice.setItems([{ label: "Ciclos de vida" }]);
    titleService.setTitle("Ciclos de vida de licença - " + AbstractService.app)
  }
  ngOnInit(): void {

  }
}
